export default "__VITE_PUBLIC_ASSET__a80b36a0__"